import { encodeURLParams } from './encodeURLParams';
import fetch, { Response } from 'node-fetch';
import { ServerError } from '@/utils/ServerError';

const MAX_ATTEMPTS = 3;

export const getBasicToken = () => {
  return Buffer.from(`${process.env.NEXUDUS_USERNAME}:${process.env.NEXUDUS_PASSWORD}`).toString('base64');
};

export const getBearerToken = async () => {
  const details = {
    username: process.env.NEXUDUS_USERNAME as string,
    password: process.env.NEXUDUS_PASSWORD as string,
    grant_type: 'password',
  };

  // Convert details to a query encoded string
  const formBody = encodeURLParams(details);

  const url = `${process.env.NEXUDUS_API_BASE_URL}/api/token`;

  let bearerToken;
  let attempts = 0;
  while (!bearerToken && attempts < MAX_ATTEMPTS) {
    try {
      const response: Response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBody,
      });

      if (response.status === 500) {
        attempts++;
        continue;
      }

      if (!response.ok) {
        return ServerError.fromMessage(
          `Request failed with status: ${response.status} ${response.statusText}`,
        ).logAndThrowRouteError();
      }

      bearerToken = await response.json();
    } catch (error) {
      return ServerError.fromError(error).withMessage('Error fetching bearer token').logAndThrowRouteError();
    }
  }

  return bearerToken.access_token as string;
};
